export default __webpack_public_path__ + "static/media/verified.7846e2a2.svg";